import styles from "./favorites-empty.module.css";

type FavoritesEmptyProps = {
  searchUrl: string;
};

function SearchIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="#6A6977"/>
    </svg>
  );
}

export function FavoritesEmpty({ searchUrl }: Readonly<FavoritesEmptyProps>) {
  return (
    <div className={styles.container} data-testid="favorites-empty">
      <div className={styles.iconWrapper}>
        <SearchIcon />
      </div>
      <div className={styles.textGroup}>
        <h2 className={styles.title}>Você ainda não tem veículos favoritos</h2>
        <p className={styles.description}>
          Busque e adicione os veículos que você gostou para poder vê-los mais tarde.
        </p>
      </div>
      <a
        href={searchUrl}
        className={styles.cta}
        target="_blank"
        rel="noopener noreferrer"
      >
        Buscar veículos
      </a>
    </div>
  );
}
